<div class="page-header" id="banner">
  <div class="row">
    <div class="col">
      <h1><a routerLink="/home">Home</a> > Feedback</h1>
    </div>
  </div>
</div>

@if (!submitted) {
  <form>
    <div class="form-group">
      <label for="emailInput">Email</label>
      <input type="emailInput" class="form-control form-control-lg" [class.is-invalid]="emailInput.invalid && (emailInput.dirty || emailInput.touched)"
        id="emailInput" name="emailInput" [(ngModel)]="feedback.email" required email #emailInput="ngModel" placeholder="something@somewhere.com">
      @if (emailInput.invalid && (emailInput.dirty || emailInput.touched)) {
        <div class="invalid-feedback">
          @if (emailInput.errors.required) {
            <div>Please enter your email address.</div>
          }
          @if (emailInput.errors.email) {
            <div>Please enter a valid email address.</div>
          }
        </div>
      }
    </div>
    <div class="form-group">
      <label for="message">Message</label>
      <textarea class="form-control form-control-lg" [class.is-invalid]="messageArea.invalid && (messageArea.dirty || messageArea.touched)"
      id="message" name="message" [(ngModel)]="feedback.message" required maxlength="500" #messageArea="ngModel" rows="6" placeholder="Make it better"></textarea>
      @if (messageArea.invalid && (messageArea.dirty || messageArea.touched)) {
        <div class="invalid-feedback">
          @if (messageArea.errors.required) {
            <div>Please enter our feedback for the site.</div>
          }
          @if (messageArea.errors.maxlength) {
            <div>Please keep your feedback somewhat brief.</div>
          }
        </div>
      }
    </div>
    <button (click)="submit()" class="btn btn-primary" [disabled]="messageArea.invalid || emailInput.invalid">Submit</button>
    <a routerLink="/home" class="btn">Cancel</a>
  </form>
}

@if (submitted) {
  <div class="alert alert-info">
    Your message has been submitted. Thank you for your feedback! It is the fastest way for me to improve the site. <a routerLink="/home">Click here</a> to return home.
  </div>
}